/* eslint-disable */
import React, { FC, useState } from 'react';
import withLocalization from '../hoc/withLocalization';
import ParseHtml from '../common/ParseHtml';
import LeadSubmitButton from './LeadSubmitButton';
import ConsentAgreementModal from '../MarketingConsentAgreement/ConsentAgreementModal';
import { maskName, maskEmail, maskPhoneNumber } from './LeadInfoUtils';
import { capitalizeFirstLetter } from '../../util/CommonLogic';
import { useCountryCodeByName } from '../../util/useCountryCodeByName';
import isAsia from '../../util/isAsia';
import './LeadInfoDetails.scss';

interface SearchPanelProps {
  localize?: any;
  localizeImages?: any;
  history: any;
  leadDetails?: any;
}
const LeadInfoDetails: FC<SearchPanelProps> = (props: SearchPanelProps) => {
  const { localize, leadDetails } = props;
  const defaultCountrylCode: any = leadDetails?.countryCode;
  const dialCode: any = useCountryCodeByName(defaultCountrylCode);
  const [isCheckedContactMe, setIsCheckedContactMe] = useState(false);
  const [consentModalOpen, setConsentModalOpen] = useState(false);
  const capFirstName = capitalizeFirstLetter(leadDetails?.firstName);
  const capLastName = capitalizeFirstLetter(leadDetails?.lastName);
  const fullName = `${capFirstName} ${capLastName}`;

  const desc = isAsia
    ? localize('preview-sales-engine.static-content.copy.pbeo.intl.asia-opt-in-description')
    : localize('preview-sales-engine.static-content.copy.pbeo.intl.me-opt-in-description');
  const clickMarketingConsent = () => {
    setConsentModalOpen(true);
  };
  const closeModal = () => {
    setConsentModalOpen(false);
  };
  const handleCheckboxClick = () => {
    setIsCheckedContactMe(!isCheckedContactMe);
  };

  return (
    <>
      {consentModalOpen && <ConsentAgreementModal closeModal={closeModal} />}
      <div className="leadInfoHeadContainer">
        <span className="leadInfo-head-wrapper">
          {localize('preview-sales-engine.static-content.copy.pbeo.verify-page-header')}
        </span>

        <span className="leadInfo-head-desc">
          {localize('preview-sales-engine.static-content.copy.pbeo.verify-page-description')}
        </span>
      </div>
      <div className="leadInfo-form">
        <div className="leadInfo-RowContainer">
          <span className="leadInfo-form-lbl">
            {localize('preview-sales-engine.static-content.copy.associate-search-page.name-label')}
          </span>
          <span className="leadInfo-form-data">{maskName(fullName)}</span>
        </div>
        <div className="leadInfo-RowContainer">
          <span className="leadInfo-form-lbl">
            {localize('preview-sales-engine.static-content.copy.associate-search-page.email-label')}
          </span>
          <span className="leadInfo-form-data">{maskEmail(leadDetails?.email)}</span>
        </div>
        <div className="leadInfo-RowContainer">
          <span className="leadInfo-form-lbl">
            {localize('preview-sales-engine.static-content.copy.associate-search-page.phone-label')}
          </span>
          <span className="leadInfo-form-data">{maskPhoneNumber(leadDetails?.phone)}</span>
        </div>
        <div className="leadInfo-consent-container">
          <div className="custom-checkbox-wrapper" id="checkboxWrapper">
            <input
              type="checkbox"
              className="custom-checkbox"
              id="customCheck"
              aria-label="custLeadCheck"
              onChange={handleCheckboxClick}
            />
          </div>
          <span className="leadInfo-consent-Desc">
            <ParseHtml htmlInput={desc}></ParseHtml>
          </span>
        </div>
        <LeadSubmitButton
          isValidForm={true}
          isEdit={false}
          email={''}
          phone={''}
          ischecked={isCheckedContactMe}
          leadDetails={leadDetails}
          dialCode={dialCode}
        />
      </div>
    </>
  );
};
export default withLocalization(LeadInfoDetails);
